// Tracciamento eventi Google Analytics 4 / Google Ads
// TODO: sostituire AW-XXXXXXX/XXXXXX con l'etichetta di conversione reale di Google Ads
export const ADS_CONVERSION = "AW-XXXXXXX/XXXXXX";

export function track(event, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", event, params);
  window.gtag("event", "conversion", { send_to: ADS_CONVERSION, event_label: event });
}
